"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.array.find");require("core-js/modules/es6.function.name");require("regenerator-runtime/runtime");var _asyncToGenerator2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator"));require("core-js/modules/es6.regexp.to-string");require("core-js/modules/es6.regexp.split");require("core-js/modules/web.dom.iterable");






































































































































































































































































var _index = require("@/utils/index");
var _formatter = require("@/utils/formatter");
var _user = require("@/utils/user");
var _aliOss = _interopRequireDefault(require("@/utils/aliOss"));
var _cryptoJs = _interopRequireDefault(require("crypto-js"));
var _sparkMd = _interopRequireDefault(require("spark-md5"));
var _lodash = _interopRequireDefault(require("lodash")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { checkType: 1, //检验类型；1：新增；2：编辑。
      showCheckErr: false, //是否显示APP和上传文件验证错误弹窗
      deviceTypeCodeList: [], //设备型号列表
      deviceSn: '', //设备搜索关键词
      deviceTableColumns: [{ prop: 'sn', label: '设备序列号' }], //表格信息
      deviceList: [], //设备列表
      tableData: [], // 列表数据
      droplist: [], imageFileList: [], sysTypeList: [{ name: 'ios', id: 1 }, { name: 'android', id: 2 }, { name: 'ipad', id: 3 }], searchData: { appId: '', appVersion: '', enabled: '', isForce: '', sysType: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, // 表格列
      tableColumns: [{ prop: 'appName', label: 'app', isShow: true }, { prop: 'appVersion', label: 'APP版本号', isShow: true }, { prop: 'notice', label: '提示语', isShow: false }, { prop: 'operatorName', label: '操作人', isShow: true }, { prop: 'sysType', label: '系统类型', formatter: _formatter.sysTypeFormatter, isShow: true }, { prop: 'isNeed', label: '是否审核中', formatter: _formatter.isAuditingFormatter, isShow: true }, { prop: 'isForce', label: '是否强制', formatter: _formatter.isForceFormatter, isShow: true }, { prop: 'enabled', label: '是否启用', formatter: _formatter.enabledFormatter, isShow: true }, { prop: 'url', label: '下载地址', isShow: false }, { prop: 'remark', label: '备注', isShow: false }, { prop: 'createTime', label: '创建时间', sortable: true, formatter: _formatter.dateFormatter, isShow: true }, { prop: 'updateTime', label: '更新时间', sortable: true, formatter: _formatter.dateFormatter, isShow: true }, { prop: 'rangeType', label: '升级范围', formatter: _formatter.otaRangeformatter, isShow: true }], pageData: { page: 1, rows: 10, total: 0, pages: 1 }, newadd: false, title: '新增', addData: { id: '', appId: '', appName: '', appVersion: '', remark: '', isForce: '', enabled: '', notice: '', sysType: '', name: '', isNeed: '0', url: '', localName: '', md5: '', rangeType: '1', rangeInfo: '' }, defaultData: { id: '', appId: '', appName: '', appVersion: '', remark: '', enabled: '', isForce: '', notice: '', sysType: '', name: '', isNeed: '0', url: '', localName: '', md5: '', rangeType: '1', rangeInfo: '' }, rules: { appId: [{ required: true, message: '请输入appId', trigger: 'blur' }], appVersion: [{ required: true, message: '请输入app版本号', trigger: 'blur' }], url: [{ required: true, message: '请上传文件', trigger: 'blur' }], sysType: [{ required: true, message: '请选择系统类型', trigger: 'blur' }], notice: [{ required: true, message: '请输入提示语', trigger: 'blur' }], isForce: [{ required: true, message: '请选择是否强制', trigger: 'blur' }], enabled: [{ required: true, message: '请选择是否禁用', trigger: 'blur' }], isNeed: [{ required: true, message: '请选择是否审核中', trigger: 'blur' }], rangeType: [{ required: true, message: '请选择升级范围', trigger: ['change'] }], devices: [{ required: true, message: '请选择升级设备', trigger: ['change'] }] } };}, mounted: function mounted() {var self = this;self.init();self.getdrop();}, computed: { isOverseas: function isOverseas() {if (process.env.VUE_APP_OG_ENV == 'americaDevelopment' || process.env.VUE_APP_OG_ENV == 'asiaProduction' || process.env.VUE_APP_OG_ENV == 'americaProduction') {//海外
        return true;} else {//国内||测试环境
        return false;}} }, methods: { /**
                                       * 根据设备型号及序列号获取设备列表
                                       */fetchDeviceList: function fetchDeviceList() {var _this = this;if (!this.deviceSn) {this.$message({ type: 'error', message: '请输入设备序列号' });return;}var url = '/api/faDeviceInfo/getAllOnlyBySn?sn=' + this.deviceSn;this.getData(url, {}, function (res) {_this.deviceList = _lodash.default.uniqBy(_this.deviceList.concat(res.list), 'sn');if (_this.addData.id) {_this.$nextTick(function () {if (_this.addData.rangeInfo && _this.addData.rangeInfo.data) {_this.deviceList.forEach(function (e) {if (_this.judgeRangeInfoHasSn(e.sn)) {_this.$refs.deviceTable.toggleRowSelection(e, true);}});}});}});}, /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       * 判断rangeInfo是否包含sn
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       */judgeRangeInfoHasSn: function judgeRangeInfoHasSn(sn) {var res = false;this.addData.rangeInfo.data.forEach(function (device) {if (sn == device.sn) {res = true;return res;}});return res;}, /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 获取设备的SN
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */getDeviceRowKey: function getDeviceRowKey(row) {return row.sn;}, /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * 设备表格是否可选
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */tableColumnSelectable: function tableColumnSelectable() {return true;}, init: function init() {var self = this;self.getData('/api/appVersion/', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;
        // console.log('1111')
        // if (self.tableData != null) {
        //   self.getData('/api/menu/button/pers', {}, function(res2) {
        //     for (var i = 0; i <= res2.length - 1; i++) {
        //       var first = res2[i]
        //       for (var j = 0; j < first.childs.length; j++) {
        //         var second = first.childs[j]
        //         for (var t = 0; t < second.childs.length; t++) {
        //           var third = second.childs[t]
        //           if (third.permission === 'app:version:add' && third.isPer) {
        //             $('.add').addClass('hide')
        //           } else if (third.permission === 'app:version:updata' && third.isPer) {
        //             $('.updata').addClass('hide')
        //           } else if (third.permission === 'app:version:del' && third.isPer) {
        //             $('.del').addClass('hide')
        //           } else if (third.permission === 'app:version:enabled' && third.isPer) {
        //             $('.enabled').addClass('hide')
        //           } else if (third.permission === 'app:version:enabled2' && third.isPer) {
        //             $('.enabled2').addClass('hide')
        //           } else if (third.permission === 'app:version:force' && third.isPer) {
        //             $('.force').addClass('hide')
        //           } else if (third.permission === 'app:version:force2' && third.isPer) {
        //             $('.force2').addClass('hide')
        //           }
        //         }
        //       }
        //     }
        //   })
        // }
      });
    },
    checkPermission: _user.checkPermission,
    resetFun: function resetFun() {// 重置
      this.searchData.appVersion = '';
      this.searchData.appId = '';
      this.searchData.enabled = '';
      this.searchData.isForce = '';
      this.searchData.sysType = '';
      this.init();
    },
    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      this.init();
    },

    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    delMenu: function delMenu(item) {
      console.log(item);
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/appVersion/' + item.id, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.newadd = true;
    },
    enableFun: function enableFun(item, type) {
      var self = this;
      if (item.enable === type) {
        this.$message({
          message: '当前状态相同，无需修改!',
          type: 'warning' });

        return;
      }
      self.$confirm('确定审核该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.postData('/api/faInstorage/' + item.id + '/' + 'audit', {
          enable: type },
        function (res) {
          self.$message({
            message: '修改成功!',
            type: 'success' });

          item.enable = type;
          self.init();
        });
      }).catch(function () {});
    },
    closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();
      this.newadd = false;
    },
    checkAppAndFileUrl: function checkAppAndFileUrl(app, fileUrl) {
      var appIdList = app.toString().split('_');
      var appId = 0;
      if (appIdList.length > 2) {
        appId = _lodash.default.take(appIdList, 2).join('');
      } else {
        appId = appIdList.join('');
      }
      var fileUrlList = fileUrl.split('/');
      var fileName = fileUrlList[fileUrlList.length - 1];
      var fileNameList = fileName.split('_');
      fileName = fileNameList[0];
      return fileName == appId;
    },
    onSubmit: function onSubmit() {var _this2 = this;
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this2.checkType = 1;
          // if (!this.checkAppAndFileUrl(this.addData.appId, this.addData.url)) {
          //   this.showCheckErr = true
          //   return
          // }
          _this2.fetchSubmit();
        } else {
          return false;
        }
      });
    },
    /**
        * 新增提交
        */
    fetchSubmit: function fetchSubmit() {
      var self = this;
      var parems = new FormData();
      parems.append('appId', self.addData.appId);
      parems.append('appVersion', self.addData.appVersion);
      parems.append('remark', self.addData.remark);
      parems.append('url', self.addData.url);
      parems.append('isForce', self.addData.isForce);
      parems.append('isNeed', self.addData.isNeed);
      parems.append('enabled', self.addData.enabled);
      parems.append('notice', self.addData.notice);
      parems.append('sysType', self.addData.sysType);
      parems.append('md5', self.addData.md5);
      parems.append('rangeType', self.addData.rangeType);
      if (parseInt(self.addData.rangeType) == 3) {
        var temp = { data: [] };
        //精准升级
        this.$refs.deviceTable.selection.forEach(function (e) {
          temp.data.push({ sn: e.sn });
        });
        if (!temp.data.length) {
          this.$message({
            message: '请选择升级设备',
            type: 'error' });

          return;
        }
        parems.append('rangeInfo', JSON.stringify(temp));
      }
      console.log('parems=======>', parems);
      // return
      self.postData('/api/appVersion', parems, function (res) {
        self.$message({
          message: '添加成功!',
          type: 'success' });

        self.deviceSn = '';
        self.onCencal();
        self.searchData.page = 1;
        self.init();
      });
    },
    updateMenu: function updateMenu(item) {var _this3 = this;
      console.log(item);
      this.title = '编辑';
      var self = this;
      this.addData = {
        id: item.id,
        remark: item.remark,
        enabled: item.enabled,
        appId: item.appId,
        appName: item.appName,
        notice: item.notice,
        url: item.url,
        appVersion: item.appVersion,
        isForce: item.isForce,
        isNeed: item.isNeed + '', // 需要加这个单引号才能选中
        sysType: item.sysType,
        md5: item.md5,
        rangeType: item.rangeType + '' };

      if (parseInt(this.addData.rangeType) == 3) {
        //精准升级
        this.deviceList = [];
        var info = JSON.parse(item.rangeInfo);
        info.data.forEach(function (e) {
          _this3.deviceList.push({ sn: e.sn });
        });
        // this.addData.rangeInfo = info
        this.$set(this.addData, 'rangeInfo', info);
      }
      self.newadd = true;
      if (parseInt(this.addData.rangeType) == 3) {
        this.$nextTick(function () {
          _this3.deviceList.forEach(function (e) {
            _this3.$refs.deviceTable.toggleRowSelection(e, true);
          });
        });
      }
    },
    onUpdate: function onUpdate(item) {var _this4 = this;
      var self = this;
      console.log('self.addData.url:', self.addData.url);
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this4.checkType = 2;
          // if (!this.checkAppAndFileUrl(self.addData.appId, self.addData.url)) {
          //   this.showCheckErr = true
          //   return
          // }
          _this4.fetchUpdate();
        } else {
          return false;
        }
      });
    },
    fetchUpdate: function fetchUpdate() {
      var self = this;
      var parems = new FormData();
      console.log(self.addData.sysType);
      parems.append('id', self.addData.id);
      parems.append('appId', self.addData.appId);
      parems.append('appVersion', self.addData.appVersion);
      parems.append('remark', self.addData.remark);
      parems.append('url', self.addData.url);
      parems.append('isForce', self.addData.isForce);
      parems.append('isNeed', self.addData.isNeed);
      parems.append('enabled', self.addData.enabled);
      parems.append('notice', self.addData.notice);
      parems.append('sysType', self.addData.sysType);
      parems.append('md5', self.addData.md5);
      parems.append('rangeType', self.addData.rangeType);
      if (parseInt(self.addData.rangeType) == 3) {
        var temp = { data: [] };
        //精准升级
        self.$refs.deviceTable.selection.forEach(function (e) {
          temp.data.push({ sn: e.sn });
        });
        if (!temp.data.length) {
          self.$message({
            message: '请选择升级设备',
            type: 'error' });

          return;
        }
        parems.append('rangeInfo', JSON.stringify(temp));
      }
      self.postData('/api/appVersion/' + self.addData.id, parems, function (res) {
        self.$message({
          message: '修改成功!',
          type: 'success' });

        self.onCencal();
        self.searchData.page = 1;
        self.init();
      });
    },
    /**
        * 检查有误，继续提交
        */
    checkErrSubmit: function checkErrSubmit() {
      this.showCheckErr = false;
      if (this.checkType == 1) {
        this.fetchSubmit();
      } else {
        this.fetchUpdate();
      }
    },
    onCencal: function onCencal() {
      this.newadd = false;
      this.deviceList = [];
      this.deviceSn = '';
      this.$refs['addForm'].resetFields();
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
    },
    auditFun: function auditFun(item, type) {
      var self = this;
      self.$confirm('确定修改该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.putData('/api/appVersion/' + item.id + '/enable', {}, function (res) {
          self.$message({
            message: '修改成功!',
            type: 'success' });

          self.init();
        });
      }).catch(function () {});
    },
    auditFun2: function auditFun2(item, type) {
      var self = this;
      self.$confirm('确定修改该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.putData('/api/appVersion/' + item.id + '/unEnable', {}, function (res) {
          self.$message({
            message: '修改成功!',
            type: 'success' });

          self.init();
        });
      }).catch(function () {});
    },
    forceFun: function forceFun(item, type) {
      var self = this;
      self.$confirm('确定修改该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.putData('/api/appVersion/' + item.id + '/force', {}, function (res) {
          self.$message({
            message: '修改成功!',
            type: 'success' });

          self.init();
        });
      }).catch(function () {});
    },
    forceFun2: function forceFun2(item, type) {
      var self = this;
      self.$confirm('确定修改该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.putData('/api/appVersion/' + item.id + '/unForce', {}, function (res) {
          self.$message({
            message: '修改成功!',
            type: 'success' });

          self.init();
        });
      }).catch(function () {});
    },

    fnUploadRequest: function () {var _fnUploadRequest = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(option) {var path;return regeneratorRuntime.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                path = "appversion/".concat(_cryptoJs.default.MD5(this.addData.appId));
                _aliOss.default.ossUploadFile(option, path);
                console.log('res.name:', option.name);case 3:case "end":return _context.stop();}}}, _callee, this);}));function fnUploadRequest(_x) {return _fnUploadRequest.apply(this, arguments);}return fnUploadRequest;}(),

    beforeUpload: function () {var _beforeUpload = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res) {var _this5 = this;var fileName, fileSuffix, readRes, fileReader;return regeneratorRuntime.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:
                fileName = res.name.toString().split('.');
                fileSuffix = fileName[fileName.length - 1].toString();
                console.log('fileSuffix======>', fileSuffix);_context2.next = 5;return (
                  (0, _index.readZipTargetFile)(res).
                  catch(function (err) {
                    console.error('readZipTargetFile=====>', err);
                  }));case 5:readRes = _context2.sent;if (!(
                (!readRes || readRes != this.addData.appId) && fileSuffix == 'img')) {_context2.next = 9;break;}
                this.$message({
                  type: 'error',
                  message: '无config文件或者文件内容有误' });return _context2.abrupt("return",

                Promise.reject(false));case 9:

                fileReader = new FileReader();
                fileReader.onload = function (e) {
                  var buffer = e.target.result;
                  var md5 = _sparkMd.default.ArrayBuffer.hash(buffer);
                  // console.log('MD5=======>',md5.toUpperCase())
                  _this5.addData.md5 = md5;
                };
                fileReader.readAsArrayBuffer(res);return _context2.abrupt("return",
                Promise.resolve(true));case 13:case "end":return _context2.stop();}}}, _callee2, this);}));function beforeUpload(_x2) {return _beforeUpload.apply(this, arguments);}return beforeUpload;}(),

    beforeRemove: function beforeRemove(file, fileList) {
      if (!file || file.status !== "success") {
        return;
      }
      var fileName = file.name;
      var confirm = '确定移除' + fileName + '?';
      return this.$confirm(confirm);
    },
    handleOnRemove: function handleOnRemove(file, fileList) {
      if (!file || file.status !== "success") {
        return;
      }
      this.$message('移除' + file.name + '成功');
    },
    onsuccess: function onsuccess(res) {
      console.log('res:', res);
      if (res && res.name) {
        var fileUrl = 'https://cdn-tech.cozzia.com.cn/' + res.name;
        this.addData.url = fileUrl;
        console.log('filePath:', fileUrl);
      }
    },
    handleChangePic: function handleChangePic(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]];
      }
    },

    getdrop: function getdrop() {
      var self = this;
      self.getData('/api/appVersion/apps', {}, function (res) {
        self.droplist = res;
      });
    },
    appFun: function appFun(data) {
      var self = this;
      self.getData('/api/appVersion/apps?appName=' + data, {}, function (res) {
        self.droplist = res;
        console.log(res);
      });
    },
    onAppIdChange: function onAppIdChange(val) {
      this.$set(this.addData, 'appName', _lodash.default.find(this.droplist, function (o) {return o.appId == val;}).name);
    } } };exports.default = _default;